export const epidemic = [
    {
      date: "26 มีนาคม 2567",
      title:
        "แจ้งเตือนผู้เลี้ยงนกแก้ว ให้ระววังโรคไข้นกแก้ว (Psittacosis) ที่เกิดจากเชื้อแบคทีเรีย Chlamydia psittaci",
    },
    {
      date: "24 มีนาคม 2567",
      title:
        "เตือนภัยโรคแอนแทรกซ์ (Anthrax) จากประเทศเพื่อนบ้านที่มีการระบาด",
    },{
      date: "23 ตุลาคม 2565",
      title:
        "แจ้งเตือนไวรัสไข้หวัดนกสายพันธุ์ H5N1 ระบาดในเวียดนาม",
    },
    {
      date: "15 มิถุนายน 2565",
      title:
        "สั่งการทุกพื้นที่ดำเนินการเข้มงวด หลังพบการแพร่ระบาดของโรคลัมปีสกินในโคและกระบือ",
    },
  ];